"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hierarchy = exports.TopNodeWrapper = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var globalCss_1 = require("@aon/aon-tws-common-ui/build/lib/globalCss");
var globalVars_module_scss_1 = __importDefault(require("@aon/aon-tws-common-ui/build/lib/globalVars.module.scss"));
var mq_1 = require("@aon/aon-tws-common-ui/build/lib/utils/styled/mq");
var mdbreact_1 = require("@aon/mdbreact/dist/mdbreact");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var org_manager_lines_png_1 = __importDefault(require("../../assets/images/org-manager-lines.png"));
var Constants_1 = require("../../Constants");
var HierarchyUtil_1 = require("../../util/HierarchyUtil");
var types_1 = require("../../types");
var Node_1 = require("./Node");
var PreviewMove_1 = require("./PreviewMove");
var HierarchyTypeUtil_1 = require("../../HierarchyTypeUtil");
var HierarchyWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tul,\n\tli {\n\t\tlist-style: none;\n\t\tpadding: ", ";\n\t}\n\tli > span {\n\t\tmargin-left: -11px;\n\t}\n\tbackground-color: ", ";\n"], ["\n\tul,\n\tli {\n\t\tlist-style: none;\n\t\tpadding: ", ";\n\t}\n\tli > span {\n\t\tmargin-left: -11px;\n\t}\n\tbackground-color: ", ";\n"])), globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.secondaryBlue);
exports.TopNodeWrapper = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin-block-end: ", ";\n"], ["\n\tmargin-block-end: ", ";\n"])), function (props) { return (props.node.nodeType === types_1.NodeType.Person ? '0em' : '1em'); });
var Divider = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"])));
var DividerLine = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tborder-bottom: ", " solid #5eafbc;\n\tline-height: 1px;\n\theight: 1px;\n\tmargin-left: ", ";\n"], ["\n\tflex-grow: 1;\n\tborder-bottom: ", " solid #5eafbc;\n\tline-height: 1px;\n\theight: 1px;\n\tmargin-left: ", ";\n"])), globalVars_module_scss_1.default.border1, globalVars_module_scss_1.default.spacing10);
var LevelContainer = (0, styled_components_1.default)(mdbreact_1.MDBRow)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t&.row {\n\t\tmargin: ", " ", " ", " ", ";\n\t}\n\t.col {\n\t\tfont-size: 12px;\n\t\tpadding: ", ";\n\t\t", "\n\t}\n\n\t", "\n"], ["\n\t&.row {\n\t\tmargin: ", " ", " ", " ", ";\n\t}\n\t.col {\n\t\tfont-size: 12px;\n\t\tpadding: ", ";\n\t\t", "\n\t}\n\n\t", "\n"])), globalVars_module_scss_1.default.spacing15, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing0, globalCss_1.textCenter, (0, mq_1.lessThan)('large')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t\tmax-width: 900px; \n\t"], ["\n\t\tmax-width: 900px; \n\t"]))));
var TreeContentContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\tcolor: ", ";\n\tmin-height: 300px;\n\tbackground: transparent;\n\tposition: relative;\n\tcursor: default;\n\toverflow: auto;\n\tbackground-image: url(", ");\n\tbackground-repeat: repeat-y;\n\tpadding: ", " ", " ", " ", ";\n\tbackground-size: ", ";\n\n\t", "\n"], ["\n\tcolor: ", ";\n\tmin-height: 300px;\n\tbackground: transparent;\n\tposition: relative;\n\tcursor: default;\n\toverflow: auto;\n\tbackground-image: url(", ");\n\tbackground-repeat: repeat-y;\n\tpadding: ", " ", " ", " ", ";\n\tbackground-size: ", ";\n\n\t", "\n"])), globalVars_module_scss_1.default.mainGray, org_manager_lines_png_1.default, globalVars_module_scss_1.default.spacing10, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.spacing60, globalVars_module_scss_1.default.spacing0, globalVars_module_scss_1.default.fullWidth, (0, mq_1.lessThan)('small')(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t\tmin-width: 900px; \n\t"], ["\n\t\tmin-width: 900px; \n\t"]))));
var NodesContainer = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\twidth: ", ";\n\tz-index: 1041;\n\tposition: relative;\n\n\t", "\n"], ["\n\twidth: ", ";\n\tz-index: 1041;\n\tposition: relative;\n\n\t", "\n"])), globalVars_module_scss_1.default.fullWidth, (0, mq_1.lessThan)('large')(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t\twidth: 900px; \n\t"], ["\n\t\twidth: 900px; \n\t"]))));
var InvalidHierarchy = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject([""], [""])));
InvalidHierarchy.displayName = 'InvalidHierarchy';
var LoadMoreOrphanNodesButtonContainer = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tmargin-left: 40px;\n\tmargin-bottom: 10px;\n"], ["\n\tmargin-left: 40px;\n\tmargin-bottom: 10px;\n"])));
var Hierarchy = /** @class */ (function (_super) {
    __extends(Hierarchy, _super);
    function Hierarchy(props) {
        var _this = _super.call(this, props) || this;
        _this.topNodesContainerRef = React.createRef();
        return _this;
    }
    Hierarchy.prototype.render = function () {
        var _this = this;
        var _a = this.props, isLoading = _a.isLoading, hierarchyHeader = _a.hierarchyHeader;
        if (isLoading) {
            return (React.createElement(aon_tws_common_ui_1.Loading, { height: '60px', width: '60px' }, "Loading..."));
        }
        return (React.createElement(HierarchyWrapper, null, (function () {
            var _a;
            if (!hierarchyHeader) {
                return React.createElement(InvalidHierarchy, null, "Invalid hierarchy");
            }
            var rootLevelNodes = (_a = _this.props.rootLevelNodes) !== null && _a !== void 0 ? _a : [];
            var levels = __spreadArray([], Array(Constants_1.Constants.LEVEL), true).map(function (x, lvl) { return lvl; });
            var width = 100 / Constants_1.Constants.LEVEL + '%';
            return (React.createElement(NodesContainer, { style: { zIndex: 1041, position: 'relative' } },
                React.createElement(LevelContainer, null, levels.map(function (level) { return (React.createElement(mdbreact_1.MDBCol, { key: level, style: { width: width } },
                    level === 0 && 'level',
                    " ",
                    level + 1)); })),
                _this.getTopNodes(rootLevelNodes, false),
                React.createElement(Divider, null,
                    React.createElement("div", null, "Unparented"),
                    React.createElement(DividerLine, null)),
                _this.getTopNodes(rootLevelNodes, true)));
        })()));
    };
    Hierarchy.prototype.getTopNodes = function (rootLevelNodes, isOrphan) {
        var _this = this;
        var nodes = this.props.nodes;
        if (!nodes) {
            return React.createElement(React.Fragment, null);
        }
        var topNodes = rootLevelNodes.map(function (nodeId) { return nodes[nodeId]; }).filter(function (n) { return !!n.isOrphan === isOrphan; });
        var topNodeKey = isOrphan ? 'OrphanNodes' : 'TopNodes';
        return (React.createElement(TreeContentContainer, { ref: !isOrphan ? this.topNodesContainerRef : null, key: topNodeKey },
            isOrphan && (React.createElement(React.Fragment, null,
                this.moveToUnparentedPlaceholder(),
                this.getOrphanedDependentNodes())),
            topNodes.map(function (n) { return _this.displayTopNode(n); })));
    };
    Hierarchy.prototype.getOrphanedDependentNodes = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, hierarchyHeader = _c.hierarchyHeader, hierarchyEditState = _c.hierarchyEditState, orphanedDependentNodeIds = _c.orphanedDependentNodeIds, nodes = _c.nodes;
        if (!nodes || !hierarchyHeader) {
            return React.createElement(React.Fragment, null);
        }
        // If moving nodes to an unparented state
        if ((0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState) && hierarchyEditState.selectedDestinationNodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID) {
            return (React.createElement(PreviewMove_1.PreviewMove, { hierarchy: this.props, moveInto: (_a = orphanedDependentNodeIds === null || orphanedDependentNodeIds === void 0 ? void 0 : orphanedDependentNodeIds.items) !== null && _a !== void 0 ? _a : [], renderNode: function (node, asPreview) { return _this.displayTopNode(__assign(__assign({}, node), { isOrphan: true }), asPreview); } }));
        }
        if (!orphanedDependentNodeIds) {
            return React.createElement(React.Fragment, null);
        }
        var topNodes = orphanedDependentNodeIds.items.map(function (i) { return nodes[i]; });
        return (React.createElement(React.Fragment, null,
            topNodes.map(function (n) { return _this.displayTopNode(n); }),
            orphanedDependentNodeIds.items.length < ((_b = orphanedDependentNodeIds.pageRange.total) !== null && _b !== void 0 ? _b : 0) && (React.createElement(LoadMoreOrphanNodesButtonContainer, null,
                React.createElement(aon_tws_common_ui_1.Button, { size: 'xs', className: 'tws-button-load-more-orphan-top-nodes', onClick: function () { return _this.props.loadMoreTopLevelOrphanNodes(); } }, "Load More")))));
    };
    Hierarchy.prototype.moveToUnparentedPlaceholder = function () {
        var _a = this.props, hierarchyHeader = _a.hierarchyHeader, hierarchyEditState = _a.hierarchyEditState, nodes = _a.nodes, _b = _a.parentIds, parentIds = _b === void 0 ? {} : _b;
        if (!hierarchyHeader || !nodes || !(0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState) || hierarchyEditState.selectedDestinationNodeId) {
            return undefined;
        }
        // Create an orphan placeholder node to facilitate moving to an unparented state
        var placeholderNode = {
            childrenIds: [],
            isExpanded: false,
            nodeId: Constants_1.Constants.ORPHAN_PLACEHOLDER_ID,
            name: 'Move to unparented',
            level: 0,
            isOrphan: true,
            fullyLoaded: false,
            nodeType: hierarchyHeader.hierarchyType === types_1.HierarchyType.Position ? types_1.NodeType.Position : types_1.NodeType.Person,
        };
        var moving = nodes[hierarchyEditState.selectedNodeId];
        var isValidMoveDestination = HierarchyTypeUtil_1.HierarchyTypeUtilFactory.getHierarchyTypeUtil(hierarchyHeader.hierarchyType).isValidMoveDestination;
        // Do not display if the node cannot be moved to this placeholder
        if (!isValidMoveDestination(placeholderNode, moving, parentIds)) {
            return undefined;
        }
        return this.displayTopNode(placeholderNode, true);
    };
    Hierarchy.prototype.displayTopNode = function (nodeData, asPreview) {
        var _a;
        var nodeId = nodeData.nodeId, _b = nodeData.isOrphan, isOrphan = _b === void 0 ? false : _b;
        var _c = this.props, hierarchy = _c.hierarchyHeader, nodes = _c.nodes, _d = _c.parentIds, parentIds = _d === void 0 ? {} : _d;
        if (!hierarchy || !nodes || (0, HierarchyUtil_1.shouldHideNode)(nodeData)) {
            return null;
        }
        return (React.createElement(exports.TopNodeWrapper, { node: nodeData, key: nodeId },
            React.createElement(Node_1.Node, __assign({}, this.props, { key: nodeId, nodeId: nodeId, level: 0, isRootNode: !isOrphan, isOrphanBranch: isOrphan, topNodesContainer: this.topNodesContainerRef, nodes: __assign(__assign({}, nodes), (_a = {}, _a[nodeId] = nodeData, _a)), parentIds: parentIds, isMovePreviewNode: !!asPreview, hierarchyHeader: hierarchy }))));
    };
    return Hierarchy;
}(React.PureComponent));
exports.Hierarchy = Hierarchy;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
